<template>
  <div>
    <router-view />
    <base-idle-dialog
      v-if="isAppIdle"
    />
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>
